module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_115_10.1cc85404.pdf";